import React, { useMemo } from 'react';
import { IntercomProvider } from 'react-use-intercom';

export const PROVIDER_CHAT_TYPE = {
  intercom: 'intercom',
};

const IntercomChat = ({ fleetInfo }) => {
  const supportSocial = fleetInfo?.supportSocial || {};

  const getAppId = (keySetting) => {
    const fullKey = keySetting || '';
    return fullKey.split('/')[0];
  };

  const getIntercomData = () => {
    if (
      supportSocial.providerDrvSignUp !== PROVIDER_CHAT_TYPE.intercom ||
      !getAppId(supportSocial.intercomDrvSignUp)
    )
      return false;
    return {
      name: 'Signup Stage 1',
      customAttributes: {
        user_type: 'Signup Stage 1',
        provider_type: 'Signup Stage 1',
      },
      appId: getAppId(supportSocial.intercomDrvSignUp),
    };
  };

  const intercomData = useMemo(() => {
    return getIntercomData();
  }, []);

  if (!intercomData) return null;

  return (
    <IntercomProvider
      appId={intercomData.appId}
      shouldInitialize={true}
      autoBoot={true}
      autoBootProps={{
        ...intercomData,
        hide_default_launcher: false,
      }}
    />
  );
};

export default IntercomChat;
